import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ServiceSelectionProvider } from './contexts/ServiceSelectionContext';
import NavBar from './Components/Navbar/NavBar';
import Hero from './Components/Hero/Hero';
import Home from './Components/Home/Home'; 
import About from './Components/About/About'; 
import Services from './Components/Services'; 
import Contact from './Components/Contact'; 
import Footer from './Components/Footer';
import BeforeAfter from './Components/B&A/BeforeAfter';
import Booking from './Components/Booking';
import FloatingBookingCart from './Components/FloatingBookingCart';
import './App.css'; 

function App() {
  return (
    <ServiceSelectionProvider>
      <Router>
        <div>
          <NavBar />
          <MainContent />
          <Footer />
          <FloatingBookingCart />
          <Toaster 
            position="top-right"
            toastOptions={{
              style: {
                background: '#fff',
                color: '#333',
                border: '1px solid #e5e7eb',
                borderRadius: '0.75rem',
                padding: '16px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
              },
              success: {
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#fff',
                },
              },
            }}
          />
        </div>
      </Router>
    </ServiceSelectionProvider>
  );
}

function MainContent() {
  const location = useLocation();
  return (
    <div>
      {location.pathname === '/' && <Hero />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/before-after" element={<BeforeAfter />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
    </div>
  );
}

export default App;


